import request from '../request'
import { BASE_API } from '../Constant'
// @todo this file name should be product service
const baseUrl = `${BASE_API}cart`

function addToCart(data) {
  return request({
    url: `${baseUrl}/add-to-cart`,
    data,
    method: 'POST',
  })
}
function updateCart(data) {
  return request({
    url: `${baseUrl}/update-quantity`,
    data,
    method: 'POST',
  });
}

function getCart(id) {
  return request({
    url: `${baseUrl}/view-order?user_id=${id}`,
    method: 'GET',
  })
}
function deleteCartById(data) {
  return request({
    url: `${baseUrl}/clear-cart-id`,
    data,
    method: 'POST',
  })
}
function deleteCart(id) {
  return request({
    url: `${baseUrl}/clear-cart?user_id=${id}`,
    id,
    method: 'POST',
  })
}
const CartServices = {
    addToCart,
    updateCart,
    getCart,
    deleteCartById,
    deleteCart
}

export default CartServices
